import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=27b8c82e&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=ts&"
export * from "./PromotionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=27b8c82e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8c82e",
  null
  
)

export default component.exports